import { render, staticRenderFns } from "./PneumoniaIndexInterpretation.vue?vue&type=template&id=250116a6&scoped=true&"
import script from "./PneumoniaIndexInterpretation.vue?vue&type=script&lang=ts&"
export * from "./PneumoniaIndexInterpretation.vue?vue&type=script&lang=ts&"
import style0 from "./PneumoniaIndexInterpretation.vue?vue&type=style&index=0&id=250116a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250116a6",
  null
  
)

export default component.exports